import pluralizer from 'pluralize';

const pluralize = (noun: string, number?: number) => {
  return pluralizer(noun, number);
};

export default pluralize;
